
import {Component, Prop, Vue} from "vue-property-decorator";
import CarCard from "@/modules/Home/components/other/CarCard.vue";
import {IHome} from "@/modules/Home/interfaces/home.interface";

  @Component({
    components: {
      CarCard,
    }
  })
  export default class HomeCars extends Vue {
    @Prop() homeData: IHome.IData;

    needRefreshCar = false;

    async openFavoriteCars() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'home',
        dialogName: 'favoriteCars',
        payload: {
          favoriteCars: this.homeData.favoriteCars
        },
      });
    }

    refreshCarInfo() {
      this.needRefreshCar = true;
      setTimeout(() => { this.needRefreshCar = false; }, 0);
    }

    updateCarInfo() {
      this.$emit('updateCarInfo');
    }
  }
